var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-image"},[_c('b-avatar',{attrs:{"rounded":"","variant":"light","size":_vm.size,"src":_vm.getSource()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }